// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-fullscreen-img[data-v-7878a9b7]{width:80%;margin:auto;background-color:#fff;z-index:1}@media only screen and (max-width: 959px){.content-fullscreen-img[data-v-7878a9b7]{margin-top:0;width:100%}}.content-fullscreen-img img[data-v-7878a9b7]{width:100%;height:auto}", ""]);
// Exports
module.exports = exports;
